<template>
  <div>
    <v-row no-gutters justify="center" align="center">

      <v-autocomplete dense outlined hide-details auto-select-first
                      name="acps"
                      id="acps"
                      type="text"
                      autocomplete="new-password"
                      placeholder="Search"
                      prepend-icon="search"
                      item-value="census_id"
                      item-text="organisation_title"
                      :items="LIST"
                      :search-input.sync="parishSearchInput"
      >
        <template v-slot:item="data">
          <div style="width: 100%" @click="handleParishSelect(data.item)">
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.organisation_title }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.organisation_district }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </div>
        </template>
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2">
                No Councils found.
              </v-list-item-title>
              <v-list-item-subtitle v-if="parishSearchInput && parishSearchInput.length < 3 && LIST.length === 0">
                Start typing to begin searching.
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="parishSearchInput && parishSearchInput.length > 2 && LIST.length === 0">
                We couldn't find anything for your search.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>

    </v-row>

    <div v-if="showParishList && !isParishSearching">
      <v-card v-if="isParishSearching">
        <v-list-item class="pt-3 pb-3">
          <v-row no-gutters justify="center" align="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-list-item>
      </v-card>

      <div v-if="LIST">
        <v-card v-if="LIST.length > 0">
          <v-row no-gutters>
            <span class="caption pl-4 pt-4 pb-1">Search Results:</span>
          </v-row>
          <div v-bar>
            <v-list dense max-height="250px">
              <v-list-item v-for="parish in LIST" @click="handleParishSelect(parish)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ parish.organisation_title }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ parish.organisation_district }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card>

        <v-card v-if="LIST.length === 0">
          <v-list-item class="pa-3 pl-6">
            <v-list-item-content>
              <v-list-item-title>
                {{ "We can't find anything for you..." }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="parishSearchInput.length > 2">
                {{ 'No Parishes found with that search value' }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else-if="parishSearchInput.length < 3">
                {{ 'Type at least 3 characters to search.' }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "ParishSearch",
    components: {},
    props: {},
    data() {
      return {
        parishSearchInput: '',
        parishSearchInputSearch: '',
        showParishList: false,
        isParishSearching: false,
      }
    },
    computed: {
      ...mapGetters({
        LIST: 'GET_PARISH_LIST',
        KEYWORD: 'GET_SEARCH_KEYWORD',
        PARISH: 'GET_SELECTED_PARISH',
      }),
    },
    methods: {
      filter(item, queryText) {
        let searchVal = this.replaceKeyword(queryText);
        let searchOn = item.search_key;

        return searchOn.indexOf(searchVal) > -1;
      },
      handleFetch() {
        if (!this.PARISH) {
          this.$store.dispatch('FETCH').then(() => {
            this.isParishSearching = false;
          });
        }
      },
      handleClearList() {
        this.$store.dispatch('CLEAR_LIST');
      },
      handleParishSelect(parish) {
        this.$store.commit('SET_SELECTED_PARISH', parish);

        this.$store.dispatch('CHECK_IF_EXISTING');

        if (!this.$store.getters.GET_PARISH_EXISTS){
          this.$store.dispatch('GET_PRICE')
        }
      },
      replaceKeyword(kw) {
        if (kw) {
          return kw.toLowerCase().replace(/\W/g, '');
        }
      },
    },
    watch: {
      parishSearchInput: function () {
        if (this.parishSearchInput) {
          if (this.replaceKeyword(this.parishSearchInput).length > 2) {
            this.isParishSearching = true;
            this.$store.commit('SET_SEARCH_KEYWORD', this.replaceKeyword(this.parishSearchInput));
            this.handleFetch()
          } else if (this.replaceKeyword(this.parishSearchInput).length === 0) {
            this.handleClearList();
          }
        } else {
          this.handleClearList();
          this.$store.commit('SET_SELECTED_PARISH', null);
        }
      },
    },
  }
</script>
